import { useSelector } from "react-redux";
import {
  getVehicle,
  getAppraisalData
} from "../../store/selectors/AppraisalSlice";
import dayjs from "dayjs";
import { howManyDaysFromNow } from "../../pages/helpers";

export const useMotExpired = (now) => {
  const { motDueDate } = useSelector(getVehicle);
  const {
    promoApplied,
    valuation: {
      valuationWithoutMotPenalty,
      promotionalBonus,
      valuationWithoutMotPenaltyBeforePromotion
    } = {}
  } = useSelector(getAppraisalData);

  const isMotExpired = dayjs(now).isAfter(dayjs(motDueDate));
  const daysFromNow = howManyDaysFromNow(now, motDueDate);
  const offeredValuation =
    promotionalBonus > 0 && promoApplied
      ? valuationWithoutMotPenalty
      : valuationWithoutMotPenaltyBeforePromotion;

  return { isMotExpired, daysFromNow, offeredValuation };
};
